import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import styles from "./subnav.module.css"

@tagName("")
export default class PlanbookMainComponent extends Component {
  readonly styles = styles
}
